import styled from '@emotion/styled'

const Container = styled.div``

export { Container }
